export default __webpack_public_path__ + "static/media/21.f1de7ab0.png";